"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var use_modal_toggle_state_hook_1 = __importDefault(require("../../hooks/use-modal-toggle-state.hook"));

var add_button_component_1 = __importDefault(require("../../common-components/add-button/add-button.component"));

var add_image_explanation_option_button_styles_1 = require("./add-image-explanation-option-button.styles");

var select_image_modal_component_1 = __importDefault(require("../select-image-modal/select-image-modal.component"));

var edit_explanation_option_view_container_1 = __importDefault(require("../edit-explanation-option-view/edit-explanation-option-view.container"));

var AddImageExplanationOptionButton = function AddImageExplanationOptionButton(_ref) {
  var addImageExplanationOption = _ref.addImageExplanationOption;

  var _use_modal_toggle_sta = use_modal_toggle_state_hook_1.default(),
      modalProps = _use_modal_toggle_sta.modalProps,
      handleOpen = _use_modal_toggle_sta.handleOpen;

  var _react_1$useState = react_1.useState(),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      selectedImage = _react_1$useState2[0],
      setSelectedImage = _react_1$useState2[1];

  return react_1.default.createElement(add_image_explanation_option_button_styles_1.StyledAddOptionButtonWrapperDiv, {
    "data-meta": "add-image-explanation-option"
  }, !selectedImage ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(add_button_component_1.default, {
    onClick: handleOpen
  }, "\u753B\u50CF\u8AAC\u660E\u8FFD\u52A0"), react_1.default.createElement(select_image_modal_component_1.default, Object.assign({}, modalProps, {
    onImageSelected: function onImageSelected(image) {
      return setSelectedImage(image);
    }
  }))) : react_1.default.createElement(edit_explanation_option_view_container_1.default, {
    imageUrl: selectedImage.url,
    imageName: selectedImage.name,
    onSave: function onSave(explanation) {
      addImageExplanationOption(selectedImage.name, selectedImage.url, explanation);
      setSelectedImage(undefined);
    },
    onCancel: function onCancel() {
      return setSelectedImage(undefined);
    }
  }));
};

exports.default = AddImageExplanationOptionButton;